import FieldContainer from '@shared/components/core/field/FieldContainer';
import StyledTextField from '@shared/components/core/field/StyledTextField';
import LocalizationLanguageField from '@shared/components/localization/LocalizationLanguageField';
import ProfileEditPageContent from '@shared/components/profile/pageContent/ProfileEditPageContent';
import { DefaultVoiceLocale } from '@shared/constants/localization/LocalizationConstants';
import { useEditProfileStore } from '@shared/hooks/state/EditProfileContainer';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

const OrgProfileEditPage: React.FC = () => {
    const { t } = useTranslation();
    const name = useEditProfileStore((state) => state.name);
    const defaultLocale = useEditProfileStore((state) => state.defaultLocale);
    const description = useEditProfileStore((state) => state.description);
    const { handleLocaleChange } = useEditProfileStore.getState();
    const headerTextFieldRef = useRef(null);

    // TODO text validation but not checking against all profiles

    // TODO add modified version of associated programs editor for org profiles
    // TODO check scroll to for all errors
    // TODO add error validation messaging

    // TODO figure out how to handle device custom controls might need a new container

    return (
        <>
            <FieldContainer>
                <LocalizationLanguageField
                    variant={'voice'}
                    value={defaultLocale || DefaultVoiceLocale}
                    onChange={handleLocaleChange}
                />
            </FieldContainer>
            <FieldContainer>
                <StyledTextField
                    fullWidth
                    label={t('common:profile.name')}
                    value={name}
                    placeholder={t('common:profile.nameQuestion')}
                    onChange={(e) => {
                        useEditProfileStore.getState().updateName(e.target.value);
                        useEditProfileStore.getState().setHasChanges(true);
                    }}
                    ref={headerTextFieldRef}
                />
            </FieldContainer>

            <FieldContainer>
                <StyledTextField
                    fullWidth
                    multiline
                    rows={3}
                    label={t('common:description')}
                    value={description || ''}
                    placeholder={t('common:description')}
                    onChange={(e) => {
                        useEditProfileStore.getState().updateDescription(e.target.value);
                        useEditProfileStore.getState().setHasChanges(true);
                    }}
                />
            </FieldContainer>

            <ProfileEditPageContent />
        </>
    );
};

export default OrgProfileEditPage;
